import { render, staticRenderFns } from "./PointManagement.vue?vue&type=template&id=13870540&scoped=true"
import script from "@/controllers/pointManagement.js?vue&type=script&lang=js&external"
export * from "@/controllers/pointManagement.js?vue&type=script&lang=js&external"
import style0 from "./PointManagement.styles.css?vue&type=style&index=0&id=13870540&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13870540",
  null
  
)

export default component.exports